import PropTypes from "prop-types";
import styles from "./styles/fit.module.css";
import { useTranslation } from "next-i18next";

const FIT_STYLES = {
  1: styles.verySmall,
  2: styles.small,
  3: styles.true,
  4: styles.larger,
  5: styles.oversized,
};

export function Fit({ trait_ratings }) {
  const fit = trait_ratings.find((trait) => trait.name.toLowerCase() === "fit");

  if (!fit) {
    return null;
  }
  const { t } = useTranslation("reviews");
  const dotStyles = `${styles.dot} ${FIT_STYLES[fit.rating]}`;
  return (
    <div className={styles.container}>
      <div className={styles.fit}>
        <span className={styles.line}>
          <span className={dotStyles}></span>
        </span>
        <div className={styles.labels}>
          <span className={styles.label}>{t(fit.label_left)}</span>
          <span className={styles.label}>{t(fit.label_center)}</span>
          <span className={styles.label}>{t(fit.label_right)}</span>
        </div>
      </div>
    </div>
  );
}

Fit.propTypes = {
  trait_ratings: PropTypes.array.isRequired,
};
